import { createContext } from 'react';

interface DirtyHandlerContextProps {
  setDirty: (dirty: boolean) => void;
  setSubmitting: (submitting: boolean) => void;
  dirty: boolean;
  submitting: boolean;
}

export const DirtyHandlerContext = createContext<DirtyHandlerContextProps>({
  dirty: false,
  submitting: false,
  setDirty: () => false,
  setSubmitting: () => false,
});

export default DirtyHandlerContext;
